// Idiomas de Cord Elements: los mismos cinco de la app de Cord.
export type CordLocale = 'es' | 'en' | 'pt' | 'fr' | 'de';

/** Etiqueta de Intl con la que se formatean importes y porcentajes en cada idioma. */
export const INTL_TAG: Record<CordLocale, string> = { es: 'es-MX', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', de: 'de-DE' };

/** 'pt-BR' → 'pt'. Sin idioma, el default documentado ('es'); uno que no se reconoce cae a inglés. */
export function cordLocale(value?: string | null): CordLocale {
    const base = String(value ?? '').trim().toLowerCase().split(/[-_]/)[0];
    if (!base) return 'es';
    return Object.prototype.hasOwnProperty.call(INTL_TAG, base) ? (base as CordLocale) : 'en';
}
